import React, { ReactElement } from 'react';
import classNames from 'classnames';
import CardBlockSC from './PaymentBlock.styled';
import CardBlock from 'components/blocks/CardBlock';
import { useTranslation } from 'utils/localization';
import H3 from 'components/typography/H3';
import PayButton from 'components/login/PayButton';

import { RequireAtLeastOne } from 'types/types';
import classes from './PayBlock.module.scss';

interface Props {
    applicationId?: string;
    amount: number;
    administrationFee?: number;
    personId?: string;
}

const PayBlock = ({
    applicationId,
    amount,
    administrationFee,
    personId: personId,
}: RequireAtLeastOne<Props, 'applicationId' | 'personId'>): ReactElement => {
    const { t } = useTranslation();

    return (
        <CardBlockSC>
            <CardBlock className={classNames('root', classes.paymentBox)}>
                <>
                    <div>
                        <H3>{t('Payment.pay') as string}</H3>

                        {applicationId && (
                            <PayButton applicationId={applicationId} />
                        )}
                        {personId && <PayButton personId={personId} />}
                    </div>
                    {!!administrationFee && (
                        <div className={classes.administrationFee}>
                            <div>
                                {t('Payment.amount')}: {amount}{' '}
                                {t('currency.czk')}
                            </div>
                            <div>
                                {t('Payment.administrationFee')}:{' '}
                                {administrationFee} {t('currency.czk')}
                            </div>
                            <div>
                                <strong>
                                    {t('Payment.totalAmount')}:{' '}
                                    {amount + administrationFee}{' '}
                                    {t('currency.czk')}
                                </strong>
                            </div>
                        </div>
                    )}
                </>
            </CardBlock>
        </CardBlockSC>
    );
};

export default PayBlock;
